<ol class="breadcrumb">
    <breadcrumbs></breadcrumbs>
</ol>
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    {{ 'common.search' | transloco }}
                </div>
                <div class="card-body">
                    <div class="form-group row">
                        <label class="col-md-2 form-control-label d-none d-lg-block">{{ 'admin.item_id' | transloco }}</label>
                        <div class="col-md-2">
                            <input type="number" [(ngModel)]="predicate.id" class="form-control" [placeholder]="'admin.item_id' | transloco">
                        </div>
                        <label class="col-md-2 form-control-label d-none d-lg-block">{{ 'admin.event_date' | transloco }}</label>
                        <div class="col-md-2">
                            <wj-input-date style="width:100%;" style="width:100%;" [(value)]="predicate.eventDate" [format]="'yyyy/MM/dd'" [isRequired]="false" [placeholder]="'admin.event_date' | transloco"></wj-input-date>
                        </div>
                        <label class="col-md-2 form-control-label d-none d-lg-block">{{ 'admin.lane' | transloco }}</label>
                        <div class="col-md-2">
                            <select class="form-control" [(ngModel)]="predicate.lane">
                                <option value="">-</option>
                                <option *ngFor="let item of optionLane" [value]="item.value">{{ item.value }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-md-2 form-control-label d-none d-lg-block">{{ 'admin.item_category' | transloco }}</label>
                        <div class="col-md-2">
                            <select class="form-control" [(ngModel)]="predicate.category">
                                <option value="">-</option>
                                <option *ngFor="let item of optionCategory" [value]="item.value">{{ item.value }}</option>
                            </select>
                        </div>
                        <label class="col-md-2 form-control-label d-none d-lg-block">{{ 'admin.auction_result' | transloco }}</label>
                        <div class="col-md-2">
                            <select class="form-control" [(ngModel)]="predicate.auctionResult">
                                <option value="">-</option>
                                <option *ngFor="let item of optionAuctionResult" [value]="item.value">{{ item.value }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-md-2 form-control-label d-none d-lg-block">{{ 'admin.item_name' | transloco }}</label>
                        <div class="col-md-2">
                            <input type="text" [(ngModel)]="predicate.name" class="form-control" [placeholder]="'admin.item_name' | transloco">
                        </div>
                        <label class="col-md-2 form-control-label d-none d-lg-block">{{ 'admin.item_description' | transloco }}</label>
                        <div class="col-md-2">
                            <input type="text" [(ngModel)]="predicate.description" class="form-control" [placeholder]="'admin.item_description' | transloco">
                        </div>
                        <div class="col-md-2">
                            <button (click)="search()" class="btn btn-primary btn-block">{{ 'common.search' | transloco }}</button>
                        </div>
                        <div class="col-md-2">
                            <button (click)="resetPredicate()" class="btn btn-success btn-block">{{ 'admin.reset' | transloco }}</button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-9">
                            <wj-flex-grid #itemGrid [isReadOnly]="false" [allowAddNew]="true" [allowDelete]="true" [selectionMode]="'CellRange'" style="height:500px" [itemsSource]="items">
                                <wj-flex-grid-filter></wj-flex-grid-filter>
                                <ng-template wjFlexGridCellTemplate [cellType]="'RowHeader'" let-cell="cell">
                                    {{isEdit(cell.row.dataItem)}}
                                </ng-template>
                                <wj-flex-grid-column binding='id' [header]="'admin.item_id' | transloco" [dataType]="'Number'" [width]="80">
                                </wj-flex-grid-column>
                                <wj-flex-grid-column binding='branch' [header]="'admin.branch_no' | transloco" [dataType]="'Number'" [width]="80">
                                </wj-flex-grid-column>
                                <wj-flex-grid-column binding='auction' [header]="'admin.auction' | transloco" [width]="150" [editor]="auctionComboBox">
                                </wj-flex-grid-column>
                                <wj-flex-grid-column binding='seller' [header]="'admin.seller' | transloco" [width]="100" [editor]="sellerAutoComplete">
                                </wj-flex-grid-column>
                                <wj-flex-grid-column binding='category' [header]="'admin.item_category' | transloco" [width]="100" [editor]="categoryComboBox">
                                </wj-flex-grid-column>
                                <wj-flex-grid-column binding='auctionResult' [header]="'admin.auction_result' | transloco" [width]="100" [editor]="auctionResultComboBox">
                                </wj-flex-grid-column>
                                <wj-flex-grid-column binding='auctionPrice' [header]="'admin.winning_price' | transloco" [dataType]="'Number'" [width]="80">
                                </wj-flex-grid-column>
                                <wj-flex-grid-column binding='name' [header]="'admin.item_name' | transloco" [width]="150">
                                </wj-flex-grid-column>
                                <wj-flex-grid-column binding='description' [header]="'admin.item_description' | transloco" [width]="200">
                                </wj-flex-grid-column>
                                <wj-flex-grid-column binding='quantity' [header]="'admin.quantity' | transloco" [dataType]="'Number'" [width]="80">
                                </wj-flex-grid-column>
                                <wj-flex-grid-column binding='unit' [header]="'admin.unit' | transloco" [width]="80" [editor]="unitComboBox">
                                </wj-flex-grid-column>
                                <wj-flex-grid-column binding='minimumPrice' [header]="'admin.minimum_price' | transloco" [dataType]="'Number'" [width]="80">
                                </wj-flex-grid-column>
                                <wj-flex-grid-column binding='startPrice' [header]="'admin.start_price' | transloco" [dataType]="'Number'" [width]="80">
                                </wj-flex-grid-column>
                                <wj-flex-grid-column binding='buyer' [header]="'admin.buyer' | transloco" [width]="100" [editor]="buyerAutoComplete">
                                </wj-flex-grid-column>
                                <wj-flex-grid-column binding='sellerCharge' [header]="'admin.seller_fee_rate' | transloco" [width]="80">
                                </wj-flex-grid-column>
                                <wj-flex-grid-column binding='buyerCharge' [header]="'admin.buyer_fee_rate' | transloco" [width]="80">
                                </wj-flex-grid-column>
                            </wj-flex-grid>
                            <wj-combo-box #auctionComboBox [itemsSource]="optionAuction" [isRequired]="true"></wj-combo-box>
                            <wj-combo-box #categoryComboBox [itemsSource]="optionCategory" [isRequired]="true" [displayMemberPath]="'value'"></wj-combo-box>
                            <wj-combo-box #auctionResultComboBox [itemsSource]="optionAuctionResult" [isRequired]="true" [displayMemberPath]="'value'"></wj-combo-box>
                            <wj-combo-box #unitComboBox [itemsSource]="optionUnit" [isRequired]="false" [displayMemberPath]="'value'"></wj-combo-box>
                            <wj-auto-complete #sellerAutoComplete [placeholder]="'admin.seller' | transloco" [itemsSource]="optionSeller" [minLength]="1"></wj-auto-complete>
                            <wj-auto-complete #buyerAutoComplete [placeholder]="'admin.buyer' | transloco" [itemsSource]="optionBuyer" [minLength]="1"></wj-auto-complete>
                        </div>
                        <div class="col-sm-3">
                            <div class="card">
                                <div class="card-header">
                                    {{ 'admin.select_images' | transloco }}
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-5">
                                            <wj-list-box class="auction" style="width: 100%; height: 150px;" [itemsSource]="imagesAvailable">
                                                <ng-template wjItemTemplate let-item="item">
                                                    <b>{{item.name}}</b><img [src]="getCurrentImageSrc(item.name)" height="50"/>
                                                </ng-template>
                                            </wj-list-box>
                                        </div>
                                        <div class="col-md-2">
                                            <button type="button" class="btn btn-default btn-lg btn-block" [title]="'admin.add_image' | transloco" (click)="addImage()"><span class="wj-glyph-right"></span></button>
                                            <button type="button" class="btn btn-default btn-lg btn-block" [title]="'admin.remove_image' | transloco" [disabled]="images.currentItem == null" (click)="removeImage()"><span class="wj-glyph-left"></span></button>
                                            <button type="button" class="btn btn-default btn-lg btn-block" [title]="'admin.move_up' | transloco" [disabled]="images.currentPosition <= 0" (click)="moveImage(-1)"><span class="wj-glyph-up"></span></button>
                                            <button type="button" class="btn btn-default btn-lg btn-block" [title]="'admin.move_down' | transloco" [disabled]="images.currentPosition >= images.itemCount - 1" (click)="moveImage(+1)"><span class="wj-glyph-down"></span></button>
                                            <button type="button" class="btn btn-default btn-lg btn-block" [title]="'common.delete' | transloco" [disabled]="imagesAvailable.currentItem == null" (click)="confirmDeleteImage()">{{ 'admin.delete_short' | transloco }}</button>
                                            <button type="button" class="btn btn-default btn-lg btn-block" [title]="'admin.rotate' | transloco" [disabled]="imagesAvailable.currentItem == null" (click)="rotateImage()">{{ 'admin.rotate_short' | transloco }}</button>
                                        </div>
                                        <div class="col-md-5">
                                            <wj-list-box class="auction" style="width: 100%; height: 150px;" [itemsSource]="images">
                                                <ng-template wjItemTemplate let-item="item" let-itemIndex="itemIndex">
                                                    #{{itemIndex+1}}&nbsp;&nbsp;<b>{{item.name}}</b><img [src]="getCurrentImageSrc(item.name)" height="50"/>
                                                </ng-template>
                                            </wj-list-box>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header">
                                    {{ 'admin.google_drive' | transloco }}
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-8">
                                            <wj-list-box class="auction" style="width: 100%; height: 150px;" [itemsSource]="googleImages">
                                                <ng-template wjItemTemplate let-item="item">
                                                    <b>{{item.name}}</b><img [src]="getGoogleImageSrc(item.id)" height="50"/>
                                                </ng-template>
                                            </wj-list-box>
                                        </div>
                                        <div class="col-md-4">
                                            <button type="button" class="btn btn-primary btn-lg btn-block" (click)="addDriveImage()">{{ 'admin.add_image' | transloco }}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-footer">
                    <div style="float:left; min-width: 150px;">
                        <wj-menu [(value)]="items.pageSize" [header]="'admin.page_size' | transloco">
                            <wj-menu-item [value]="100">100</wj-menu-item>
                            <wj-menu-item [value]="500">500</wj-menu-item>
                            <wj-menu-item [value]="1000">1000</wj-menu-item>
                        </wj-menu>
                    </div>
                    <div style="float:left; min-width: 150px;">
                        <wj-collection-view-navigator [cv]="items"></wj-collection-view-navigator>
                    </div>
                    <div style="float:left; min-width: 150px;">
                        <wj-collection-view-pager [cv]="items"></wj-collection-view-pager>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <button [disabled]="!items.hasChanges()" (click)="saveChanges()" class="btn btn-primary btn-block">{{ 'admin.save_changes' | transloco }}</button>
        <button [disabled]="!items.hasChanges()" (click)="cancelChanges()" class="btn btn-primary btn-block">{{ 'common.cancel' | transloco }}</button>
    </div>
</div>
<cb-modal-confirm #deleteImagePopup (onConfirm)="deleteImage()" [modalClass]="'modal-danger'" [closeButton]="'common.cancel' | transloco" [confirmButton]="'common.delete' | transloco" [title]="'common.delete' | transloco" [content]="message"></cb-modal-confirm>
